function ArabicStatLine({ label, value, className = "", valueClassName = "data-value" }) {
  return (
    <span className={className}>
      {label}: <span className={valueClassName} dir="ltr">{value}</span>
    </span>
  );
}

export default ArabicStatLine;
